/* tslint:disable */
/* eslint-disable */
/**
 * Bonds API
 * Microservice backend for bond management
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * 
 * @export
 * @enum {string}
 */
export enum UpdateTypeEnum {
    LustrationIsirStart = 'LUSTRATION_ISIR_START',
    LustrationIsirEnd = 'LUSTRATION_ISIR_END',
    LustrationDphStart = 'LUSTRATION_DPH_START',
    LustrationDphEnd = 'LUSTRATION_DPH_END',
    LustrationLiquidationStart = 'LUSTRATION_LIQUIDATION_START',
    LustrationLiquidationEnd = 'LUSTRATION_LIQUIDATION_END',
    FinancialResultNew = 'FINANCIAL_RESULT_NEW',
    ReturnsPaid = 'RETURNS_PAID',
    ReturnsNotPaid = 'RETURNS_NOT_PAID',
    ReturnsPeriod = 'RETURNS_PERIOD',
    Invested25 = 'INVESTED_25',
    Invested50 = 'INVESTED_50',
    Invested75 = 'INVESTED_75',
    Invested100 = 'INVESTED_100',
    DocumentAdded = 'DOCUMENT_ADDED',
    CollateralAdded = 'COLLATERAL_ADDED',
    CollateralRemoved = 'COLLATERAL_REMOVED',
    ChangeAddress = 'CHANGE_ADDRESS',
    ChangeOwner = 'CHANGE_OWNER',
    NewIssue = 'NEW_ISSUE',
    ChangeIssueParameter = 'CHANGE_ISSUE_PARAMETER',
    News = 'NEWS'
}


export function UpdateTypeEnumFromJSON(json: any): UpdateTypeEnum {
    return UpdateTypeEnumFromJSONTyped(json, false);
}

export function UpdateTypeEnumFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdateTypeEnum {
    return json as UpdateTypeEnum;
}

export function UpdateTypeEnumToJSON(value?: UpdateTypeEnum | null): any {
    return value as any;
}

